module.exports = __webpack_public_path__ + "static/media/onboarding_cover.5bf5252e.jpg";